export default __webpack_public_path__ + "static/media/d16969fef9da73233dda1f4caea258a9.png";